module.exports = __webpack_public_path__ + "_SiteFooter-static.html";